export default __webpack_public_path__ + "assets/certificates/steel_rope_certificate.638f374f.pdf";